const cleanArray = (arr, ref) => {
  let res = [];
  arr.forEach((each, i) => {
    if (each !== '') {
      if (ref) {
        ref.forEach(ea => {
          if (each !== ea) {
            res.push(each);
          }
        });
      } else {
        res.push(each);
      }
    }
  });
  return res;
};
export default cleanArray;



// WEBPACK FOOTER //
// ./src/helpers/cleanArray.js